export const GET_TRASH_ITEMS = 'GET_TRASH_ITEMS'
export const GET_TRASH_ITEMS_SUCCESS = 'GET_TRASH_ITEMS_SUCCESS'
export const GET_TRASH_ITEMS_FAILURE = 'GET_TRASH_ITEMS_FAILURE'

export const CLEAR_ALL_TRASH = 'CLEAR_ALL_TRASH'
export const CLEAR_ALL_TRASH_SUCCESS = 'CLEAR_ALL_TRASH_SUCCESS'
export const CLEAR_ALL_TRASH_FAILURE = 'CLEAR_ALL_TRASH_FAILURE'

export const RESTORE_ASSETS = 'RESTORE_ASSETS'
export const RESTORE_ASSETS_SUCCESS = 'RESTORE_ASSETS_SUCCESS'
export const RESTORE_ASSETS_FAILURE = 'RESTORE_ASSETS_FAILURE'

export const DELETE_ASSETS = 'DELETE_ASSETS'
export const DELETE_ASSETS_SUCCESS = 'DELETE_ASSETS_SUCCESS'
export const DELETE_ASSETS_FAILURE = 'DELETE_ASSETS_FAILURE'

export const MOVE_ASSETS = 'MOVE_ASSETS'
export const MOVE_ASSETS_SUCCESS = 'MOVE_ASSETS_SUCCESS'
export const MOVE_ASSETS_FAILURE = 'MOVE_ASSETS_FAILURE'

export const DOWNLOAD_ASSETS = 'DOWNLOAD_ASSETS'
export const DOWNLOAD_ASSETS_SUCCESS = 'DOWNLOAD_ASSETS_SUCCESS'
export const DOWNLOAD_ASSETS_FAILURE = 'DOWNLOAD_ASSETS_FAILURE'

export const GET_TRASH_USAGE_LIST = 'GET_TRASH_USAGE_LIST'
export const GET_TRASH_USAGE_LIST_SUCCESS = 'GET_TRASH_USAGE_LIST_SUCCESS'
export const GET_TRASH_USAGE_LIST_FAILURE = 'GET_TRASH_USAGE_LIST_FAILURE'